import React from 'react';

const ZoomOutIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16pt" height="16pt" viewBox="0 0 24 24" className="svg-icon zoom-out-icon" {...props}>
        <path
            d="M 23.328125 23.332031 C 22.757812 23.902344 21.828125 23.902344 21.253906 23.332031 L 16.632812 18.707031 C 12.609375 21.714844 6.90625 21.433594 3.246094 17.773438 C -0.761719 13.765625 -0.761719 7.261719 3.246094 3.246094 C 7.261719 -0.761719 13.765625 -0.761719 17.773438 3.246094 C 21.433594 6.90625 21.714844 12.613281 18.707031 16.632812 L 23.328125 21.253906 C 23.902344 21.832031 23.902344 22.757812 23.328125 23.332031 Z M 15.699219 5.324219 C 12.832031 2.457031 8.1875 2.457031 5.324219 5.324219 C 2.457031 8.1875 2.457031 12.835938 5.324219 15.699219 C 8.1875 18.5625 12.835938 18.5625 15.699219 15.699219 C 18.5625 12.835938 18.5625 8.1875 15.699219 5.324219 Z M 14.636719 11.464844 L 6.132812 11.464844 L 6.132812 9.511719 L 14.636719 9.511719 Z M 14.636719 11.464844 "
        />
    </svg>
);

export default ZoomOutIcon;



// WEBPACK FOOTER //
// ./src/components/ZoomOutIcon.js